import React, { useEffect, Suspense } from "react";
import { useSearchParams } from "next/navigation";
import { VStack, Heading, Text } from "@chakra-ui/react";
import Tabs from "@/components/tabs";
import { useSectionHeadingVariant } from "@/theme/components/useSectionHeading";
import { TEXT_VARIANTS } from "@/theme/components/text";
import { scrollToElement } from "@/utils/scrollToElement";
import { SERVICES_CONSTANTS } from "./constants";
import { tablist } from "./serviceTabsList";

const ID = "cloud-services-tab";

const useHandleScroll = () => {
  const searchParams = useSearchParams();
  const tab = searchParams.get("tab");
  useEffect(() => {
    if (tab) {
      scrollToElement(ID, 120);
    }
  }, [tab]);
};

const CloudCardsTabs = () => {
  useHandleScroll();
  const headingVariant = useSectionHeadingVariant();
  return (
    <VStack id={ID} spacing={4}>
      <Heading as="h1" variant={headingVariant}>
        {SERVICES_CONSTANTS.title}
      </Heading>
      <Text variant={TEXT_VARIANTS.LABEL1} color={"text.100"} fontWeight={700}>
        {SERVICES_CONSTANTS.desc}
      </Text>
      <Suspense>
        <Tabs columns={{ base: 1, sm: 2 }} tabList={tablist} />
      </Suspense>
    </VStack>
  );
};

export default CloudCardsTabs;
